import React from 'react';
import AurButton from '../common/aur-button/AurButton';
import {ReactComponent as PlusIconSuccess} from '../../assests/svg/plus-icon.svg';
import {ReactComponent as PlusIconZeroState} from '../../assests/svg/plus-icon-disabled.svg';
import {Typography} from '@mui/material';
import {t} from 'i18next';
interface BulkUploadSuccessStateprops {
  successCount: number; // Number of users added successfully
  handleAddUsersClick: () => void; // Handler for the "Add Users" button click
}
const BulkUploadSuccessState: React.FC<BulkUploadSuccessStateprops> = ({
  successCount,
  handleAddUsersClick,
}) => {
  return (
    <div className="usersuccess-container usersuccess-button">
      <div className="userswithouterrors">
        <div className="userswithouterrors-value">
          <Typography className="typo-text display3_size mist_100" gutterBottom>
            {successCount}
          </Typography>
          <div className="userswithouterrors-text">
            <Typography className="typo-text body2_size mist_100" gutterBottom>
              {successCount === 1
                ? t('common.bulkUploadModule.teamMemberWithoutError')
                : t('common.bulkUploadModule.teamMembersWithoutError')}{' '}
            </Typography>
          </div>
        </div>
      </div>
      <div className="addxmembers-button">
        <AurButton
          classNames="addxmemberssuccess-btn"
          type="continue"
          startIcon={
            successCount === 0 ? <PlusIconZeroState aria-hidden="true" /> : <PlusIconSuccess aria-hidden="true" />
          }
          label={
            successCount === 0
              ? t('common.bulkUploadModule.addZeroUsers')
              : successCount === 1
                ? t('common.bulkUploadModule.addTeamMember')
                : `${t('common.bulkUploadModule.add')} ${successCount} ${t('common.bulkUploadModule.teamMembers')}`
          }
          size="Medium"
          onClick={handleAddUsersClick}
          disabled={successCount === 0} // Button is disabled when successCount is 0
          dataTestId="adduser-button"
        />
      </div>
    </div>
  );
};

export default BulkUploadSuccessState;
